import template from './pageLayout.html';
import controller from './pageLayout.controller';
import './pageLayout.scss';

export default {
  restrict: 'E',
  transclude: true,
  bindings: {
    page: '@',
    title: '@',
    headerConfig: '<',
    hideHeader: '<',
    hideSideBar: '<',
    hideFooter: '<',
    wideView: '<',
    currentRegion: '<'
  },
  template,
  controller,
  controllerAs: 'vm'
};



/** WEBPACK FOOTER **
 ** ./client/app/components/common/pageLayout/pageLayout.component.js
 **/